/** 正文组件共用逻辑 */
export const bodyMixin = {
	props: {
		data: {
			type: Object,
			required: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select', 'update'],
	methods: {
		onWrapClick(e) {
			if (!this.editable) return;
			e?.stopPropagation?.();
			this.$emit('select');
		},
		onContentUpdate(content) {
			this.$emit('update', { content });
		},
	},
};
